//* Import the functions you need from the SDKs you need
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

//* Add the Web App's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAM9HpSfuaxAkzvh6lup8KZ0TGZikGg0zY",
  authDomain: "inner-art2.firebaseapp.com",
  projectId: "inner-art2",
  storageBucket: "inner-art2.firebasestorage.app",
  messagingSenderId: "327447013622",
  appId: "1:327447013622:web:d7ddeb2f0d9b7760d064d7",
  measurementId: "G-5V974BCXSZ",
};

//* Initialize Firebase
let firebase_app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

//* Initialize Firebase Auth and set persistence
const auth = getAuth(firebase_app);
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Session persistence set to LOCAL");
  })
  .catch((error) => {
    console.error("Failed to set session persistence:", error);
  });

export { auth };
export default firebase_app;
